import { DIM } from '../../configs/config'
import { Ghost, withRipple } from '../../base/components/advanced/ghost/ghost'
import { Base } from '../../base/components/base'
import router from '../../base/lib/router'
import {emitter} from '../../base/utils/emitter'
import { MenuIconBar } from '../menu/menu-icon-bar'
import { CENTER } from '../../base/helpers/style'

export const BackIcon = () => {

    const height = 4
    const base = Base('div')
    const top = MenuIconBar(height)
    const bottom = MenuIconBar(height)

    emitter.on('route-changed', (r: string) => {
        r == '/' ? hide() : show()
    })


    base.el.onclick = () => router.back()

    top.style({
        // top: '15px',
        // right: '10px',
        position: 'absolute',
        transform: `rotateZ(-45deg)`
    })
    bottom.style({
        // bottom: '23px',
        // right: '10px',
        position: 'absolute',

        transform: `rotateZ(45deg)`
    })

    const ghost = Ghost({ bg: 'white' })
    base.el.addEventListener('touchstart', (e) => {
        ghost.activate(e.touches[0].pageX, e.touches[0].pageY)
        base.style({
            transform: 'scale(.9)'
        })
    })
    base.el.addEventListener('touchend', () => {
        ghost.deactivate()
        base.style({
            transform: 'scale(1)'
        })
    })
    base.append(top, bottom, ghost)

    base.cssClass({
        position: 'fixed',
        right: `0`,
        top: `5px`,
        margin: '20px',
        width: '22px',
        height: '22px',
        transition: 'all .16s',
        zIndex: '99999',
        opacity: '0',
        transform: 'translateY(50px) rotateX(180deg)',
        userSelect: 'none',
        cursor: 'pointer',
        ...CENTER
    })
    withRipple(base)
    function show() {
        base.style({
            opacity: '1',
            transform: 'translateY(0) rotateX(0deg)'
        }, { delay: 500 })
    }
    function hide() {
        base.style({
            opacity: '0',
            transform: 'translateY(50px) rotateX(180deg)'
        })
    }


    return base
}